import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { OpenaiService } from '../services/openai.service'

export class TextResponse {
  text: string = ''
  response: any = ''
}

@Component({
  selector: 'app-open-ai',
  templateUrl: './open-ai.component.html',
  styleUrls: ['./open-ai.component.css'],
})
export class OpenAiComponent implements OnInit {
  textResponse: TextResponse = new TextResponse()
  loading: boolean = false

  constructor(private openaiService: OpenaiService, public authService: AuthService, private router: Router) { }

  ngOnInit() {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['notFound'])
    }
  }

  get getSessionExpired() {
    if (!this.authService.isLoggedIn()) {
      return this.router.navigate(['/login'])
    }
  }

  generateText() {
    this.loading = true;
    this.textResponse.response = ''
    this.openaiService.generateText(this.textResponse.text).then((text) => {
      this.textResponse.response = text
      this.textResponse.text = ''
      this.loading = false
    });
  }
}